module.exports = __webpack_public_path__ + "img/icon_integrador_de_dados.c9aeec6a.png";